// extracted by mini-css-extract-plugin
module.exports = {"title":"SpeakersFullList_title__13Fn4","speakers":"SpeakersFullList_speakers__3GRFP","speakersItem":"SpeakersFullList_speakersItem__1i0UT"};